import { BaseModel } from "./base"
import { JsonProperty } from "../requests/jsonparser";

export class Contest {

    @JsonProperty({ type: 'false' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'Contest' })
    MODELNAME: string;

    @JsonProperty({ type: 'number' })
    id: number

    @JsonProperty({ type: 'string' })
    email: string

    @JsonProperty({ type: 'string' })
    contest: string

    @JsonProperty({ type: 'string' })
    share_token: string

    @JsonProperty({ type: 'number' })
    iUserID: number
}



// WEBPACK FOOTER //
// ./src/api/src/models/contest.ts